<template>
	<div class="form" id="variant">
		<div class="form-wrapper">
			<p class="section-title">{{ title }}</p>
			<p class="section-description">{{ text }}</p>

			<span
				v-show="
					error_material.status &&
						submitted &&
						!this.form['material_name']
				"
				class="form-error"
				>{{ error_material.message }}</span
			>
			<modal
				ref="variant"
				@submitted="setMaterial"
				v-bind="{ product_handle, product_title, success }"
			></modal>

			<textarea
				rows="8"
				id="message"
				v-model="form.message"
				:placeholder="this.$translations.form.message"
			>
			</textarea>

			<span v-show="errors.has('name') && submitted" class="form-error">{{
				errors.first("name")
			}}</span>
			<input
				v-validate="'required'"
				id="name"
				name="name"
				type="text"
				v-model="form.name"
				:placeholder="this.$translations.form.name"
			/>

			<span
				v-show="errors.has('email') && submitted"
				class="form-error"
				>{{ errors.first("email") }}</span
			>
			<input
				v-validate="'required|email'"
				name="email"
				id="email"
				type="email"
				v-model="form.email"
				:placeholder="this.$translations.form.email"
			/>
			<input type="hidden" id="gclid_field" name="gclid_field" value="" />

			<input type="hidden" id="cid_field" name="cid" value="" />

			<div class="terms">
				<div class="checkbox-wrapper">
					<input
						v-model="agreed_terms.status"
						type="checkbox"
						name="conditions"
						id="conditions"
						@change="agreed_terms.error = false"
					/>
					<a target="_blank" :href="terms">
						{{ this.$translations.cart.terms_text }}
					</a>
				</div>
				<div class="form-error" v-if="agreed_terms.error">
					{{ this.$translations.cart.terms_error }}
				</div>
			</div>

			<button
				@click="submit"
				:class="['btn-submit', 'varianter', { 'btn-loading': loading }]"
			>
				{{ this.$translations.form.send }}
			</button>

			<div class="form-error" v-if="error">
				{{ this.$translations.form.error }}
			</div>

			<div class="form-success" v-if="success">
				{{ this.$translations.form.post_success }}
			</div>
		</div>
	</div>
</template>

<script>
import modal from "../modal.vue";
import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import axios from "axios";

Vue.use(VeeValidate);
export default {
	components: {
		modal
	},
	props: {
		product_handle: { required: true },
		product_title: { required: true },
		title: { required: true },
		text: { required: true },
		terms: { required: false }
	},
	data() {
		return {
			form: {
				url: window.location.href,
				agreed: ""
			},
			loading: false,
			error: false,
			submitted: false,
			success: false,
			error_material: {
				status: false,
				message: this.$translations.product.modal_error
			},
			agreed_terms: {
				status: false,
				error: false
			},
			version: this.$translations.general.version
		};
	},
	methods: {
		setMaterial(value) {
			let name = `material_${this.version}`;
			let price = `price_${this.version}`;

			this.form["material_name"] = value[name];
			this.form["material_price"] = value[price];
		},

		submit() {
			this.submitted = true;
			if (
				this.form["material_name"] != null &&
				this.agreed_terms.status
			) {
				this.$validator.validateAll().then((isValid) => {
					if (isValid) {
						this.form.agreed = this.agreed_terms.status
							? "agreed"
							: "not agreed";
						this.send();
					}
				});
			} else {
				if (!this.form["material_name"]) {
					this.error_material.status = true;
				}
				if (!this.agreed_terms.status) {
					this.agreed_terms.error = true;
				}
			}
		},
		async send() {
			this.loading = true;
			let additionalData = {
				cid: document.querySelector("#cid_field").value,
				gclid: document.querySelector("#gclid_field").value
			};

			let form = { ...this.form, ...additionalData };

			await axios
				.post("https://mailer.signifly.com/api/klassik/mail", form)
				.then((response) => {
					this.submitted = false;
					this.error_material.status = false;
					this.success = true;
					this.loading = false;
					this.form = {
						url: window.location.href,
						message: "",
						name: "",
						email: "",
						material_name: "",
						material_price: ""
					};
					this.agreed_terms.status = false;
				})
				.catch((e) => {
					this.error = true;
				});
		}
	},
	computed: {
		formData() {
			return {
				data: Object.entries(this.form).map(([key, value]) => ({
					key,
					value
				}))
			};
		},
		btnText() {
			return this.loading ? "Loading..." : this.$translations.form.send;
		}
	}
};
</script>

<style lang="scss" scoped>
.form-success,
.form-error {
	margin-top: 8px;
}
.form-success {
	color: $vintage;
}
.terms {
	@include terms;
}
</style>
